import React from 'react';
import { Fish, Disc, Utensils, ShoppingBag } from 'lucide-react';
const products = [{
  title: 'Whole Fish',
  description: 'Premium selection of whole frozen fish including Croaker, Mackerel, and Tilapia.',
  icon: Fish,
  color: 'bg-blue-50 text-blue-600'
}, {
  title: 'Fish Fillets',
  description: 'Clean, bone-free fillets perfect for quick preparation and restaurant menus.',
  icon: Disc,
  color: 'bg-teal-50 text-teal-600'
}, {
  title: 'Shrimp & Prawns',
  description: 'Various sizes of frozen shrimp and prawns, ideal for stir-frys, stews, and grilling.',
  icon: Utensils,
  color: 'bg-indigo-50 text-indigo-600'
}, {
  title: 'Specialty Seafood',
  description: 'Squid, crab, and other specialty items for diverse culinary needs.',
  icon: ShoppingBag,
  color: 'bg-slate-50 text-slate-600'
}];
export function Products() {
  return <section id="products" className="py-20 bg-slate-50" data-id="element-137">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-139">
          <h2 className="text-base font-semibold text-teal-600 tracking-wide uppercase" data-id="element-140">
            Our Selection
          </h2>
          <p className="mt-2 text-3xl font-bold leading-8 text-slate-900 sm:text-4xl" data-id="element-141">
            Premium Frozen Offerings
          </p>
          <p className="mt-4 text-xl text-slate-500" data-id="element-142">
            We stock a wide variety of high-quality frozen seafood products to
            meet the needs of households and businesses alike.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-143">
          {products.map((product, index) => <div key={index} className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden border border-slate-100" data-id="element-144">
              <div className="p-8" data-id="element-145">
                <div className={`w-12 h-12 rounded-lg ${product.color} flex items-center justify-center mb-6`} data-id="element-146">
                  <product.icon className="h-6 w-6" data-id="element-147" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-148">
                  {product.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-149">
                  {product.description}
                </p>
              </div>
              <div className="px-8 py-4 bg-slate-50 border-t border-slate-100" data-id="element-150">
                <span className="text-sm font-medium text-teal-600 flex items-center" data-id="element-151">
                  Available in Bulk & Retail
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}